import {lemon, lemonReady} from "../common/lemon";
import {valid} from "../common/valid";
import {previewImage} from "../common/previewer";

lemonReady(function (){
    lemon(".image-previewer").on("click", function (){
        previewImage({src: lemon(this).el[0].getAttribute("src"), image_path: lemon(this).el[0].getAttribute("data-image_path")});
    });

});